import * as React from "react";
import { Consent, JourneyContext, PublicAction, PublicPrefillData, SamPrefillData } from "../../common/types";
import { registerActionComponent } from "./action_registry";
import { registerCampaignTargetProvider } from "./campaign_target_provider_registry";
import { registerCaptchaProvider } from "./captcha_provider_registry";
import { registerUtilityComponent } from "./utility_component_registry";
export { mergeContexts } from "@flow/common/logic/journey";

export type { MemberRouteArgs } from "./FrontendMemberRoute";
export { createFrontendMemberRoute } from "./FrontendMemberRoute";

export interface RootDispatch {
  gotoNextStep(actionStatus: "skipped" | "completed", updatedContext: JourneyContext, consents: Consent[]): void;
  setBackground(imageUrl?: string, setBackgroundColour?: string): void;
}

export interface ActionProps {
  action: PublicAction;
  variant_idx: number;
  dispatch: RootDispatch;
  ctx: JourneyContext;
  // if Member details are known from previous sessions,
  // a redacted partial copy of these will be in redacted_prefill
  redacted_prefill: PublicPrefillData | undefined;
  consents: Consent[] | undefined;
  isStaff: boolean;
  takenAction: boolean;
  sam_prefill: SamPrefillData | undefined;
  show_journey_title: boolean | undefined;
}

export type ActionComponentProps<T_custom_data> = ActionProps & {
  custom: T_custom_data;
};

export type ActionComponent<T_custom_data> =
  | React.FunctionComponent<ActionComponentProps<T_custom_data>>
  | React.ComponentClass<ActionComponentProps<T_custom_data>>;

export const pluginRegistry = {
  registerActionComponent,
  registerCampaignTargetProvider,
  registerCaptchaProvider,
  registerUtilityComponent,
};
